export const ELEMENT_HYPER_LINK = 'hyperLink';
